import { createContext, PropsWithChildren } from 'react'

/**
 * @deprecated Use IsInArcadeModalContext with Arcade Modal from @cash-design-system/react instead
 */
export const IsInModalContext = createContext(false)

/**
 * @deprecated Use ArcadeModal which provides IsInArcadeModalContext automatically
 */
export const ModalContextProvider = ({ children }: PropsWithChildren) => (
  <IsInModalContext.Provider value={true}>{children}</IsInModalContext.Provider>
)
